{
  "myList": {
    "title": "MIS ESPACIOS",
    "createButton": "+ crear espacio",
    "defaultProductType": "Proyecto",
    "roleMember": "miembro",
    "searchPlaceholder": "Buscar espacios...",
    "noSpacesFound": "No se encontraron espacios"
  },
  "dashboard": {
    "changeLogoTooltip": "Cambiar Logo",
    "namePlaceholder": "Nombre del Espacio",
    "descriptionPlaceholder": "Añade una descripción...",
    "editSpaceButton": "Editar espacio",
    "generated": "Generado",
    "timezone": "Zona horaria",
    "language": "Idioma",
    "visibility": "Visibilidad",
    "visibilityPrivate": "Privado",
    "visibilityPublic": "El mundo nos ve",
    "unknownDate": "Desconocida",
    "membersTitle": "MIEMBROS ({{count}})",
    "searchMemberPlaceholder": "Buscar miembro...",
    "addGuestsButton": "+ Agregar invitados",
    "detailsTitle": "DETALLES DEL ESPACIO",
    "spaceType": "Tipo de espacio",
    "industry": "Industria",
    "plan": "Plan",
    "storage": "Almacenamiento",
    "storageUsedPercent": "{{percent}}% usado",
    "taskCount": "Número de tareas",
    "docCount": "Documentos",
    "creationDate": "Fecha de creación",
    "recentActivityTitle": "ACTIVIDAD RECIENTE",
    "noRecentActivity": "No hay actividad reciente.",
    "noDetail": "Sin detalle",
    "defaultProductType": "Proyecto",
    "defaultVisibility": "Privado",
    "defaultIndustry": "General",
    "defaultPlan": "Enterprise"
  },
  "settingsMenu": {
    "subtitle": "Configuración del espacio",
    "general": {
      "title": "General",
      "subtitle": "Información básica del espacio"
    },
    "members": {
      "title": "Miembros y permisos",
      "subtitle": "Usuarios y roles"
    },
    "safe": {
      "title": "Seguridad",
      "subtitle": "Autenticación y sesiones"
    },
    "integrations": {
      "title": "Integraciones",
      "subtitle": "Conecta tus herramientas"
    },
    "ai": {
      "title": "IA y automatizaciones",
      "subtitle": "Modelos, agentes, y flujos"
    },
    "template": {
      "title": "Apariencia",
      "subtitle": "Tema, colores y marca"
    },
    "notifications": {
      "title": "Notificaciones",
      "subtitle": "Canales y preferencias"
    },
    "storage": {
      "title": "Almacenamiento",
      "subtitle": "Uso y configuración"
    },
    "billing": {
      "title": "Facturación y pagos",
      "subtitle": "Plan, pagos, y consumo"
    },
    "dangerzone": {
      "title": "Zona peligrosa",
      "subtitle": "Eliminar o transferir espacio"
    }
  }
}